import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Browser fallback for the universal / app link `https://<spa-host>/subscribe-to/:code`.
 *
 * When the mobile app IS installed, iOS/Android intercept the tap via the
 * apple-app-site-association / assetlinks.json association and this component
 * never runs. It only executes when the link is opened in a browser, in which
 * case we hand off to the API's subscribe-to endpoint, which sniffs the user
 * agent and redirects to the correct app store (carrying the sales code through
 * an Android referrer or an iOS post-install token).
 */
@Component({
    selector: 'app-subscribe-redirect',
    template: `<p class="subscribe-redirect">Opening the Good Neighbor app&hellip;</p>`,
    styles: [
        `.subscribe-redirect {
            font-family: sans-serif;
            text-align: center;
            margin-top: 3rem;
        }`,
    ],
})
export class SubscribeRedirectComponent implements OnInit {
    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        const code = this.route.snapshot.paramMap.get('teamMemberCode') ?? '';

        // environment.apiBaseURL ends in '/api/', but the subscribe-to endpoint is
        // mapped at the API root ([Route("subscribe-to")]), so strip the suffix.
        const apiOrigin = environment.apiBaseURL.replace(/\/api\/?$/, '');

        window.location.replace(`${apiOrigin}/subscribe-to/${encodeURIComponent(code)}`);
    }
}
